import React, { useEffect, useMemo, useState } from "react";
import SalaryType from "./HRSetting/Salary/SalaryType";
import ShgType from "./HRSetting/Shg/Shg";
import LeaveType from "./HRSetting/Leave/LeaveType";

const HRSettings = () => {
  const storedScreens = JSON.parse(localStorage.getItem("screens") || "{}");

  const canLeave = Boolean(storedScreens?.leaveSettingIndex);
  const canSalary = Boolean(storedScreens?.salarySettingIndex);
  const canShg = Boolean(storedScreens?.shgSettingIndex);

  /* -------------------- PERMISSION BASED TABS -------------------- */
  const tabs = useMemo(() => {
    const list = [];
    if (canLeave) list.push({ id: "leave", label: "Leave" });
    if (canSalary) list.push({ id: "salary", label: "Salary" });
    if (canShg) list.push({ id: "shg", label: "SHG" });
    return list;
  }, [canLeave, canSalary, canShg]);

  const [activeTab, setActiveTab] = useState(tabs[0]?.id);

  /* -------------------- KEEP ACTIVE TAB VALID -------------------- */
  useEffect(() => {
    if (tabs.length && !tabs.some((t) => t.id === activeTab)) {
      setActiveTab(tabs[0].id);
    }
  }, [tabs, activeTab]);

  /* -------------------- NO ACCESS SAFETY -------------------- */
  if (!tabs.length) return null;

  return (
    <div className="p-1">
      {/* TAB HEADER */}
      <div className="container-fluid p-0 my-2">
        <div className="card shadow-sm border-0 p-2">
          <div className="d-flex gap-3 px-2 overflow-auto">
            {tabs.map((tab, index) => (
              <React.Fragment key={tab.id}>
                <button
                  className={`btn btn-sm fw-semibold ${
                    activeTab === tab.id ? "active-tab-btn" : "inactive-tab-btn"
                  }`}
                  style={{
                    border: activeTab === tab.id ? "none" : "1px solid #ddd",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label.toUpperCase()}
                </button>

                {index < tabs.length - 1 && (
                  <span style={{ color: "#e5e5e5" }}>|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* TAB CONTENT */}
      <div className="container">
        <div className="card shadow-sm mt-3 p-3">
          {activeTab === "leave" && canLeave && <LeaveType />}
          {activeTab === "salary" && canSalary && <SalaryType />}
          {activeTab === "shg" && canShg && <ShgType />}
        </div>
      </div>
    </div>
  );
};

export default HRSettings;
